module.exports = "<div ui-view=main id=mainview> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/twinfield/twinfield.html
// module id = 523
// module chunks = 0